import React, { useState } from "react";
import { ReactComponent as BackArrow } from "../../assets/navbar/BackArrow.svg";
import { ReactComponent as RecipeImg } from "../../assets/analyse/AnalyseRecipe.svg";
import { ReactComponent as DeliveryIcon } from "../../assets/analyse/DeliveryIcon.svg";
import { ReactComponent as ConsumptionIcon } from "../../assets/analyse/consumption.svg";
import { ReactComponent as RetailIcon } from "../../assets/analyse/retail.svg";
import { ReactComponent as DistributionIcon } from "../../assets/analyse/distribution.svg";
import { ReactComponent as Plus } from "../../assets/analyse/Plus.svg";
import "react-toastify/dist/ReactToastify.css";
import AnalysisLine from "./AnalysisLine";
import "react-widgets/styles.css";
import StepResult from "./StepResult";
import ColabMenu from "./ColabMenu";
// import spinach from "../../app_data/ingredients/ref_ing_spinach.json";
import { isDisabled } from "@testing-library/user-event/dist/utils";
import { columnsNames } from "../../css/columns";
import ReduceSubstep from "./ReduceSubstep";
import ReduceAnalysisLine from "./ReduceAnalysisLine";

const ReduceStep = ({ name, hidden, setHidden, icon, size, data, width, columns, ingredients, totalScore, depth }) => {
  const hiddenindex = data.step_index + depth * 5;
  const [collabMenu, setCollabmenu] = useState("");
  const [menupos, setmenupos] = useState({ x: 0, y: 0 });
  const [wastes, setWastes] = useState([null]);
  var result = data.outputs[0]; //result.impact + "%";

  const get_current_transport_data = (ingredients, current) => {
    const ingred = Object.entries(ingredients).find((x) => x[0] === current.id);
    // const ingred = Object.entries(ingredients).find((x) => x[0] === current.flow.id);
    const transport_data = !(ingred[1].__typename === "Flow") ? ingred[1].find((x) => x.category.name === "K_Transports") : [];
    return transport_data;
  };

  const check_any_optimization_results = (transport_data) => {
    return transport_data.inputs && transport_data.inputs.some((x) => x.custom_analysis);
  };

  return (
    <>
      {collabMenu ? <ColabMenu colabMenu={collabMenu} menuPos={menupos} name={name} setColabMenu={setCollabmenu} /> : null}
      <div className={`w-[600px]`}>
        <div className={"h-full"}>
          {/* CSSM STEP HEADER */}
          <div className={`h-[40px] bg-white border-[0.1px] boder-[#F3F5F7] flex w-max`}>
            <div style={{ width: width }} className={`items-center flex justify-between`}>
              <button
                className="flex items-center"
                onClick={() => {
                  let newhidden = [...hidden];
                  newhidden[hiddenindex] = !newhidden[hiddenindex];
                  setHidden(newhidden);
                }}
                onContextMenu={(event) => {
                  event.preventDefault();
                  let pos = { x: event.pageX, y: event.pageY };
                  setmenupos(pos);
                  setCollabmenu(1);
                }}
              >
                <BackArrow transform={`rotate(${270 - 90 * (hidden[hiddenindex] ? hidden[hiddenindex] : 0)})`} className="ml-[15px]" height={10} />

                <div className={"w-[40px] justify-center flex"}>
                  {icon === "Recette" ? (
                    <RecipeImg height={20} />
                  ) : icon === "Packaging" ? (
                    <DeliveryIcon height={20} />
                  ) : icon === "Distribution" ? (
                    <DistributionIcon height={20} />
                  ) : icon === "Vente au détail" ? (
                    <RetailIcon height={20} />
                  ) : icon === "Consommation" ? (
                    <ConsumptionIcon height={20} />
                  ) : null}
                </div>
                <p className="font-Poppins-SemiBold">{name}</p>
              </button>

              {/* <button
                onClick={() => {
                  setAddMenu(1);
                }}
              >
                <Plus height={10} />
              </button> */}
            </div>
          </div>

          {hidden[hiddenindex] ? null : (
            <div className={`ml-[30px]`}>
              {Object.values(data.inputs).map((current, i) => {
                if (ingredients && check_any_optimization_results(get_current_transport_data(ingredients, current))) {
                  return (
                    <ReduceSubstep
                      hidden={hidden}
                      setHidden={setHidden}
                      key={"current.custom_analysis.flow.name_fr" + i}
                      name={current.flow.name_fr}
                      columns={columns}
                      depth={depth + 1}
                      width={width}
                      icon={icon}
                      // icon={current.flow.category.name}
                      totalScore={totalScore}
                      data={get_current_transport_data(ingredients, current).inputs.filter((x) => x.custom_analysis)[0]}
                      is_ingredient={true}
                      step={data.step_index}
                    />
                  );
                }
                if (current.custom_analysis !== undefined) {
                  return (
                    <ReduceSubstep
                      hidden={hidden}
                      setHidden={setHidden}
                      key={"current.custom_analysis.flow.name_fr" + i}
                      name={current.custom_analysis.flow.name_fr}
                      columns={columns}
                      depth={depth + 1}
                      width={width}
                      icon={icon}
                      // icon={current.custom_analysis.flow.category.name}
                      totalScore={totalScore}
                      data={current}
                      step={data.step_index}
                    />
                  );
                }
                if (depth === 0 && (current.flow.category.name === "K_Wastes" || current.flow.category.name === "K_Food_Given")) {
                  return;
                }
                return (
                  <AnalysisLine
                    key={`${current.flow.name_fr}` + `${i}`}
                    item={current.flow.name_fr}
                    quantity={current.amount}
                    quantityUnit={current.unit.name}
                    // impact={(((current.flow.flow_impact_factors.find((i) => i.name === "Unique Score").coefficient * current.amount) / totalScore) * 100).toFixed(2)}
                    impact_factors={current.flow.flow_impact_factors}
                    checked={current.checked}
                    // TO_ACTIVATE_CHANGABLE
                    // changable={
                    //   current.flow.category.name === "K_Cooking" || current.flow.category.category_path.includes("Transformation") === true ? null : data.step_index <= 2 ? ingredients : current
                    // }
                    width={width}
                    columns={columns}
                    step={data.step_index}
                    line_index={i}
                    // flow_id={current.flow.id}
                    flow_id={current.id}
                    is_reduce={true}
                    icon={current.flow.category.name}
                    conversion_factor={current.unit.conversion_factor}
                  />
                );
              })}
              {Object.keys(data.inputs.filter((x) => x.custom_analysis === undefined && (x.flow.category.name === "K_Wastes" || x.flow.category.name === "K_Food_Given"))).length > 0 && depth === 0 ? (
                <ReduceStep
                  hidden={hidden}
                  setHidden={setHidden}
                  key={name}
                  columns={columns}
                  name={"Déchets et revalorisation"}
                  icon={"Distribution"}
                  width={width - 30}
                  size={1}
                  ingredients={null}
                  totalScore={totalScore}
                  data={{
                    outputs: [null],
                    step_index: data.step_index,
                    inputs: data.inputs.filter((x) => x.custom_analysis === undefined && (x.flow.category.name === "K_Wastes" || x.flow.category.name === "K_Food_Given")),
                  }}
                  step={data.step_index}
                  depth={depth + 1}
                />
              ) : null}
            </div>
          )}
          {result == null ? null : <StepResult result={result} />}
        </div>
      </div>
    </>
  );
};

export default ReduceStep;
